import { useMemo } from 'react';
import { FeatureTree } from '../config/feature-tree';
import { useAppHandlingContext } from '../contexts/app-handling.context';
import { useSettingsContext } from '../contexts/settings.context';
import { useAppParams } from './app-params.hook';
export function isWallet(tile) {
    return (tile === null || tile === void 0 ? void 0 : tile.wallet) != null;
}
export function useFeatureTree() {
    const { language } = useSettingsContext();
    const { setParams } = useAppParams();
    const { setRedirectPath } = useAppHandlingContext();
    const supportedLanguages = ['EN', 'DE', 'IT', 'FR'];
    function getPage(pageId, allowedTiles) {
        var _a;
        if (!language)
            return;
        const nextPage = (_a = FeatureTree.find((p) => p.id === pageId)) !== null && _a !== void 0 ? _a : FeatureTree[0];
        const tiles = nextPage.tiles
            .map((t) => (Object.assign(Object.assign({}, t), { img: getImgUrl(t, language) })))
            .filter((t) => !allowedTiles || allowedTiles.includes(t.id));
        return Object.assign(Object.assign({}, nextPage), { tiles });
    }
    function getWallet(tile, params) {
        return typeof tile.wallet === 'function' ? tile.wallet(params) : tile.wallet;
    }
    function getImgUrl(tile, lang) {
        var _a;
        const language = (_a = supportedLanguages.find((l) => l === lang.symbol)) !== null && _a !== void 0 ? _a : supportedLanguages[0];
        return `https://content.dfx.swiss/img/v1/services/${tile.img}_${language.toLowerCase()}.png`;
    }
    function setOptions(options) {
        // service
        if (options.service)
            setRedirectPath(`/${options.service}`);
        // query
        if (options.query) {
            setParams(options.query);
        }
    }
    return useMemo(() => ({ getPage, getWallet, setOptions }), [language, setParams]);
}
